import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import { addModal } from 'core/notifications';

import { Insignias } from 'uikit/insignias';
import { Skeleton } from 'uikit/loaders';
import { Typo } from 'uikit/content';

import ChallengeModalContainer from '../containers/challengeModalContainer';
import ProfileChallengesList from './profileChallengesList';

import styles from '../styles/profileChallenges.module.scss';

const ProfileChallenges = ({
  data = {},
  isCurrentUser = false,
  isLoading = true,
  isMyLearning = false,
  trophiesCount = 0,
}) => {
  const handleActiveChallengesClick = (id) => {
    addModal({
      component: <ChallengeModalContainer id={id} />,
      hasCloseButton: true,
    });
  };

  const insignias = [
    {
      ariaLabel: i18n.t('count-trophies', { count: trophiesCount }),
      icon: 'trophy',
      text: trophiesCount ? trophiesCount.toString() : '0',
      tooltip: i18n.t('trophies'),
    },
  ];

  const { active: activeChallenges, completed: completedChallenges } = data;

  return (
    <section className={styles.container}>
      <header className={styles.header}>
        <Typo element="h2" variant="d02">
          {i18n.t('challenges')}
        </Typo>
        {isLoading ? (
          <Skeleton className={styles.insignias} width={50} height={26} />
        ) : (
          <Insignias className={styles.insignias} insigniasIconSize={18} insignias={insignias} />
        )}
      </header>
      <ProfileChallengesList
        activeChallenges={activeChallenges}
        completedChallenges={completedChallenges}
        isCurrentUser={isCurrentUser}
        isLoading={isLoading}
        isMyLearning={isMyLearning}
        onActiveChallengesClick={handleActiveChallengesClick}
      />
    </section>
  );
};

ProfileChallenges.propTypes = {
  data: PropTypes.shape({
    active: PropTypes.arrayOf(
      PropTypes.shape({
        challenge_id: PropTypes.number,
        name: PropTypes.string,
        challenge_picture: PropTypes.shape({
          w96: PropTypes.string,
        }),
      }),
    ),
    completed: PropTypes.arrayOf(
      PropTypes.shape({
        challenge_id: PropTypes.number,
        name: PropTypes.string,
        challenge_picture: PropTypes.shape({
          w96: PropTypes.string,
        }),
      }),
    ),
  }),
  isCurrentUser: PropTypes.bool,
  isLoading: PropTypes.bool,
  isMyLearning: PropTypes.bool,
  trophiesCount: PropTypes.number,
};

export default React.memo(ProfileChallenges);
